var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.707 18.7074C11.5195 18.8949 11.2652 19.0002 11 19.0002C10.7349 19.0002 10.4806 18.8949 10.293 18.7074L4.29303 12.7074C4.10556 12.5199 4.00024 12.2656 4.00024 12.0004C4.00024 11.7352 4.10556 11.4809 4.29303 11.2934L10.293 5.29341C10.4816 5.11125 10.7342 5.01045 10.9964 5.01273C11.2586 5.01501 11.5094 5.12018 11.6948 5.30559C11.8803 5.491 11.9854 5.74181 11.9877 6.00401C11.99 6.2662 11.8892 6.5188 11.707 6.70741L7.41403 11.0004H19C19.2652 11.0004 19.5196 11.1058 19.7071 11.2933C19.8947 11.4808 20 11.7352 20 12.0004C20 12.2656 19.8947 12.52 19.7071 12.7075C19.5196 12.8951 19.2652 13.0004 19 13.0004H7.41403L11.707 17.2934C11.8945 17.4809 11.9998 17.7352 11.9998 18.0004C11.9998 18.2656 11.8945 18.5199 11.707 18.7074V18.7074Z",
  fill: "#222735"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back-arrow.86044d06893dab593a6aa2f17d4b24f4.svg";